import moment from "moment/moment";
import { adminApi, ipRegistry, ipStackClient, adminCardApi } from ".";
import { ApiControllers } from "./config";
import CryptoJS from "crypto-js";

const changePassword = (customerId) => {
  return adminApi.get(ApiControllers.customer + `ResetPWD/${customerId}`);
}
const getCustomerNameLookup = (email, name) => {
  return adminApi.get(ApiControllers.customer + `Customers/${email}/${name}`)
}
const convertUTCToLocalTime = (dateString) => {
  let date = new Date(dateString);
  const milliseconds = Date.UTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds()
  );
  const localTime = new Date(milliseconds);
  return localTime.toISOString();
};
const isErrorDispaly = (objValue) => {
  if ((objValue?.status > 400 && objValue?.status < 500) && objValue?.status != 401) {
    return "Something went wrong please try again!";
  } else {
    if (objValue?.data && typeof objValue?.data === "string") {
      return objValue?.data;
    } else if (objValue?.data && objValue?.data?.title && typeof objValue?.data?.title) {
      return objValue?.data?.title;
    } else if (
      objValue?.originalError &&
      typeof objValue?.originalError?.message === "string"
    ) {
      return objValue?.originalError?.message;
    } else {

      return typeof (objValue) === "object" && objValue?.reason ? objValue?.reason : "Something went wrong please try again!";
    }
  }
};
const uploadErrorDisplay = (objValue) => {
  if ((objValue?.status >= 400 && objValue?.status < 500) && objValue?.status != 401) {
    return "Something went wrong please try again!";
  } else if (objValue?.title && typeof objValue?.title) {
    return objValue?.title;
  } else {
    return "Something went wrong please try again!";
  }
}

const fetchAdminDetails = () => {
  return adminApi.get(ApiControllers.registration + `App/Exchange`)
}
const fetchModules = (url) => {
  return adminApi.get(ApiControllers.customer + `AdminApps/AdminApps`);
}
const encryptValue = (msg, key) => {
  msg = typeof msg == "object" ? JSON.stringify(msg) : msg;
  let salt = CryptoJS.lib.WordArray.random(128 / 8);

  let key1 = CryptoJS.PBKDF2(key, salt, {
    keySize: 256 / 32,
    iterations: 10,
  });

  let iv = CryptoJS.lib.WordArray.random(128 / 8);

  let encrypted = CryptoJS.AES.encrypt(msg, key1, {
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });
  return salt.toString() + iv.toString() + encrypted.toString();
};
const getIpRegistery = () => {
  return ipRegistry.get("/?key=" + process.env.REACT_APP_IPREGISTERY_KEY);
};
const getIpStack = () => {
  return ipStackClient.get('check?access_key=' + process.env.REACT_APP_IPSTACK_KEY)
}

const getMenuLink = (id) => {
  return adminApi.get(ApiControllers.security + `MenuLinks/` + id);
}

//Transcations

const getCryptoPayeeslookupData = () => {
  return adminApi.get(ApiControllers.common + `currencylu`)
}

const getCryptoCurrencyLookup = () => {
  return adminApi.get(ApiControllers.common + `CurrencyLookUp`)
}

const getTranslookupData = (email, name) => {
  return adminCardApi.get(ApiControllers.customer + `Customers/${email}/${name}`)
}
const getCryptoTransTypelookupData = () => {
  return adminApi.get(ApiControllers.exchangetransaction + `Exchange/Types`)
}


const transactionDetails = (transactionId) => {
  return adminApi.get(ApiControllers.exchangetransaction + `transaction/${transactionId}`)

}

const downloadTransaction = (id, type) => {
  return adminApi.get(ApiControllers.exchangetransaction + `TemplatesTranction/${id}/${type}`);
}
const getTranssourceData = () => {
  return adminApi.get(ApiControllers.common + `TxSourceLookup`)
}
const getTranslookup = () => {
  return adminApi.get(ApiControllers.common + `TransactionLookUp`)
}
//Customer
const getCustomerView = (customerId) => {
  return adminApi.get(ApiControllers.common + `ProfileView/${customerId}`)
}
const getCustomerProfileInfo = (url) => {
  return adminCardApi.get(ApiControllers.common + url)
}
//-----------------------Grid Metadata start---------------------------
const gridColumnsData = (screenName, id) => {
  return adminApi.get(ApiControllers.security + `/GridMetaData/${screenName}/${id}?url=https%3A%2F%2Fdevdigitalbankapi.artha.work%2F`)
}
const getGridMetaData = (screenName,userId) => {
  return adminCardApi.get(ApiControllers.security + `GridMetaData/${screenName}/${userId}`)
}
const gridSaveLayout = (obj) => {
  return adminApi.post(ApiControllers.security + `SaveLayout`, obj)
}
const gridResetLayout = (screenName, userId) => {
  return adminApi.delete(ApiControllers.security + `ResetLayOut/${screenName}/${userId}`)
}
//-----------------------Grid Metadata end---------------------------
const cardsuspense = (obj) => {
  return adminCardApi.put(ApiControllers.allCards + `Card/Suspensed`, obj)
}
const getLookupsForCardForm = () => {
  return adminCardApi.get(ApiControllers.common + `CardCreationLu`);
}
const getCountries = () => {
  return adminCardApi.get(ApiControllers.common + `/States`)
}
const getpaidCurrencyluData = () => {
  return adminCardApi.get(ApiControllers.customer + "Cards/PaidCurrencyLu")
}
const getCardDetails = (url) => {
  return adminCardApi.get(ApiControllers.allCards + `Cards/${url}`)
}
const postNewCard = (obj) => {
  return adminCardApi.post(ApiControllers.allCards + `cardSave`, obj);
}
const updateExistingCard = (obj) => {
  return adminCardApi.put(ApiControllers.allCards + `UpdateCard`, obj);
}
const updateCardStatus = (obj) => {
  return adminCardApi.put(ApiControllers.allCards + `cardStatusUpdate`, obj)
}
const getCardsPermissionsConfig = (type, custId) => {
  return adminCardApi.get(ApiControllers.security + `Permissions/${type}/${custId}`)
}
const WalletTransactionLookUp = () => {
  return adminCardApi.get(ApiControllers.common + `WalletTransactionLookUp`)
}
const getCards = (userid, type) => {
  return adminCardApi.get(ApiControllers.allCards + `CustomerCards/${userid}/${type}`);
}
const getcardTypeLuData = () => {
  return adminCardApi.get(ApiControllers.common + `CardTypeLookup`)
}
const getCardsNamesLudata = (custId) => {
  return adminCardApi.get(ApiControllers.exchangetransaction + `CardsLu/${custId}`)
}
const getCardsTransLudata = () => {
  return adminCardApi.get(ApiControllers.common + `CardTransactionLookUp`)
}
const updateStateChangePayee = (obj) => {
  return adminApi.put(ApiControllers.common + `Address/Status`, obj)
}
const getPermissionsConfig = (type, custId) => {
  return adminCardApi.get(ApiControllers.security + `Permissions/${type}/${custId}`)
}
const getUserNameLookup = (name) => {
  return adminApi.get(ApiControllers.common + `UsersLookUp/${name}`)
}
//Payees
const getPayeeCustomerNameLookup = (email, name) => {
  return adminCardApi.get(ApiControllers.customer + `Customers/${email}/${name}`)
}
const getStateChangeLookUp = (type, state) => {
  return adminApi.get(ApiControllers.common + `statechange/AddressBook ${type}/${state}`)
}
//Audit Logs
const getauditLuData = () => {
  return adminApi.get(ApiControllers.common + `AuditLogLookUp`)
}
const getAuditLogInfo = (id) => {
  return adminApi.get(ApiControllers.common + `AuditlogInfo/${id}`)
}
//Cases Start
const featchCaseDetails = (id) => {
  return adminApi.get(ApiControllers.case + `Admin/Case/${id}`)
}
const featchCaseSatateLu = (screenName, state) => {
  return adminApi.get(ApiControllers.common + `statechange/${screenName}/${state}`)
}
const assignedAdmins = () => {
  return adminApi.get(`Case/AdminUsers`)
}
const casesTemplate=()=>{
  return adminApi.get(`Case/TemplateLu`)
}
const deleteCaseAssigners=(id)=>{
  return adminApi.delete(`Case/CaseAssigners/${id}`);
}
//Cases End

//User Profile
const getProfileDetails = (id) => {
  return adminApi.get(ApiControllers.customer + `CustomerProfile/${id}`)
}
const resetPassword = (customerId) => {
  return adminApi.get(ApiControllers.security + `ResetPWD/${customerId}`);
}
const updateCustomerDetails = (obj) => {
  return adminApi.put(ApiControllers.customer + `CustomerProfile`, obj)
}
const getCustomerVerifications = (id) => {
  return adminApi.get(ApiControllers.customer + `Custumer/Verification/${id}`)
}
const getCustomerStateLu = (state) => {
  return adminApi.get(ApiControllers.common + `statechange/Customer/${state}`)
}
const customerVerifications = (obj) => {
  return adminApi.put(ApiControllers.customer + `Verification`, obj)
}
const confirmStateChange = (obj) => {
  return adminApi.put(ApiControllers.customer + `StateUpdate`, obj);
}
const enableAffiliate=(obj)=>{
  return adminApi.put(ApiControllers.common + `UpdateBusinessStatus`, obj);
}
//customerCards
const getCardNameLookup = (cardType) => {
  return adminApi.get(ApiControllers.allCards + `AdminCardsLu/${cardType}`)
}
const getAddress = (id) => {
  return adminApi.get(ApiControllers.allCards + `Cards/Address/${id}`)
}
const updateCustomerState = (body) => {
  return adminApi.put(ApiControllers.allCards + `Cards/StateChange`, body)
}
const getCardTypeLookup = () => {
  return adminApi.get(ApiControllers.common + `CardTypeLookup`)
}
//dateConverter
const formatDates = (dates) => {
  return dates.map(date => moment(date).format('YYYY-MM-DD')).join('/');
};
const excelCryptotransactionGrid = (name, currencies, type, currencyType, allSearch) => {
  return adminApi.get(ApiControllers.exchangetransaction + `Admin/Cryptotransactions/${name}/${currencies}/${type}/${currencyType}/${allSearch}`)
}

const excelBanktransactionGrid = (name, currencies, type, allSearch) => {
  return adminApi.get(ApiControllers.exchangetransaction + `Admin/Banktransactions/${name}/${currencies}/${type}/${allSearch}`)
}


const excelWalletstransactionGrid = (name, currencies, type, allSearch) => {
  return adminApi.get(ApiControllers.exchangetransaction + `Wallets/Admin/Cryptotransactions/${name}/${currencies}/${type}/${allSearch}`)
}
const fetchTierLu = () => {
  return adminApi.get(ApiControllers.commissions + `CustomerTierLu`)
}
const getCommissions = (id) => {
  return adminApi.get(ApiControllers.commissions + `Commission/${id}`);
}
const getCustomerCommissions = (customerId) => {
  return adminApi.get(`${ApiControllers.commissions}CustomerFee/${customerId}`);
}
const saveCommision = (type, obj) => {
  if (type == 'add') {
    return adminApi.post(ApiControllers.commissions + 'UpdateCustomerCommissions', obj)
  } else {
    return adminApi.put(ApiControllers.commissions + 'UpdateCustomerCommissions', obj)
  }
}
const fetchCustomerTemplateLu = (customerId) => {
  return adminApi.get(ApiControllers.commissions + `CustomerTemplateLu/${customerId}`)
}
const fetchCustomerFee = (customerId) => {
  return adminApi.get(ApiControllers.commissions + `CustomerFee/${customerId}`)
}
//Exchange Api calls 
const exchangewalletLu=()=>{
  return adminApi.get(ApiControllers.exchangetransaction+`CurrencyLookUp`)
}


const BankAccountsLU = () => {
  return adminApi.get(ApiControllers.exchangeWallet + `Admin/FiatCodesLu`)
}


const getCreateConfigData=()=>{
  return adminApi.get(ApiControllers.customer + `MetafConfiguration`)
}
const saveConfiguration = (obj) => {
  return adminApi.post(ApiControllers.customer + `SaveMetafConfiguration`, obj)
}
const carddetails = (custId, cardid) => {
  return adminApi.get(ApiControllers.allCards + `CardDetails/${custId}/Card/${cardid}`)
}
const customerCommissionSave = (obj) => {
  return adminApi.post(`Common/CustomerCommissions`, obj);
}
const referralUpdate = (obj) => {
  return adminApi.put(`Customer/ReferralUpdate`, obj);
}
const referralCode = (code) => {
  return adminCardApi.get(`Customer/CustomerReferral/${code}`)
}
const postNewNote = (obj) => {
  return adminCardApi.post(ApiControllers.common + `SaveNotes`, obj);
}

const getNoteDetails = (noteId) => {
  return adminCardApi.get(ApiControllers.common + `Notes/${noteId}`)
}

const updateExistingNote = (obj) => {
  return adminCardApi.put(ApiControllers.common + `UpdateNotes`, obj);
}

const updateNoteStatus = (obj) => {
  return adminCardApi.put(ApiControllers.common + `NoteStatusUpdate`, obj)
}
const freezeunfreezeCard = (obj, custId) => {
  return adminCardApi.put(ApiControllers.allCards + `Admin/${custId}/Card/${obj.id}/FreezeUnFreeze`, obj)
}


const saveTemplate = (obj) => {
  return adminCardApi.post(`Case/SaveCaseTemplate`, obj);

}

const deleteCaseTemplate = (id) => {
  return adminCardApi.delete(`Case/DeleteTemplate/${id}`)
}

const getCasesTemplate = (id) => {
  return adminCardApi.get(`Case/CasesTemplate/${id}`)
}
const getCasesview = (id) => {
  return adminCardApi.get(`Case/Admin/Case/${id}`)
}
const getStateChangeLu=(state)=>{
  return adminCardApi.get(`Case/statechange/Cases/${state}/null`)

}
const updateStateChange=(obj)=>{
  return adminCardApi.post(`ExchangeTransaction/WithdrawCrypto/StateChange`,obj)
}
const getCustomerPersonalInfo=(url)=>{
  return adminCardApi.get(ApiControllers.common+`Customer/${url}`)
  }
const getTransactionActionsLu=(type)=>{
  return adminApi.get(ApiControllers.exchangetransaction + `Exchange/ActionTypes/${type}`);
}
const getDocumentReplies=(id)=>{
  return adminApi.get( `Case/Accounts/${id}/Messages`);
}
const getTypeOfFiles = () =>{
  return adminApi.get(`Import/ImportTypes`) ;
}
const ProfileImageSave = (obj) => {
  return adminApi.put(ApiControllers.customer + "Avatar", obj);
}
const getTransStateLu=(state)=>{
  return adminApi.get( ApiControllers.common+`statechange/Transaction/${state}`);
}
const getKYCDetails=(id)=>{
  return adminApi.get(ApiControllers.allCards + `CustomerCard/KycDetials/${id}`) ;
}
const apporveorRejectKyc=(obj)=>{
  return adminApi.put(ApiControllers.allCards + `AdminApproveCardsStateChange`,obj) ;
}
const getStatesLu=()=>{
  return adminApi.get(ApiControllers.common + `SubscriptionStateLookup`) ;
}
//apicalls
const apiCalls = {getMenuLink,uploadErrorDisplay,convertUTCToLocalTime,getUserNameLookup,getauditLuData,getAuditLogInfo,
 isErrorDispaly, changePassword, fetchAdminDetails, encryptValue,getCustomerNameLookup,getIpStack,getIpRegistery,getCustomerView,getCustomerProfileInfo,gridColumnsData,cardsuspense,
 getLookupsForCardForm,getCountries,getpaidCurrencyluData,getCardDetails,postNewCard,updateExistingCard,updateCardStatus,getCardsPermissionsConfig,fetchModules,getPermissionsConfig,getStateChangeLookUp,updateStateChangePayee,getCryptoPayeeslookupData,getCryptoCurrencyLookup,
getTranslookupData,getCryptoTransTypelookupData,transactionDetails,downloadTransaction,WalletTransactionLookUp,getPayeeCustomerNameLookup,getCards,getcardTypeLuData,getCardsNamesLudata,getCardsTransLudata,getGridMetaData,getProfileDetails,resetPassword,updateCustomerDetails,getCustomerVerifications,getCustomerStateLu,customerVerifications,confirmStateChange,
getCardNameLookup,getAddress,updateCustomerState,getCardTypeLookup,formatDates,excelCryptotransactionGrid,excelBanktransactionGrid,excelWalletstransactionGrid,
fetchTierLu,getCommissions,saveCommision,fetchCustomerTemplateLu,fetchCustomerFee,getCustomerCommissions,
getCreateConfigData,saveConfiguration,carddetails,customerCommissionSave,referralUpdate,referralCode,exchangewalletLu,getTranssourceData,getTranslookup,freezeunfreezeCard,postNewNote,getNoteDetails,updateExistingNote,updateNoteStatus,BankAccountsLU,featchCaseDetails,featchCaseSatateLu,assignedAdmins,casesTemplate,getCasesview,getCasesTemplate,deleteCaseTemplate,saveTemplate,getStateChangeLu,updateStateChange,getTransStateLu,
getCustomerPersonalInfo,getTransactionActionsLu,getDocumentReplies,deleteCaseAssigners,getTypeOfFiles,ProfileImageSave,enableAffiliate,getKYCDetails,apporveorRejectKyc,getStatesLu,
gridSaveLayout, gridResetLayout
}
export default apiCalls